module.exports = __webpack_public_path__ + "static/media/HomePageMinus_72dpi.cd2637c1.png";